<template>
  <b-tabs
    v-model="model"
    class="tabs_vertical"
    vertical
    expanded
    :animated="false"
  >
    <slot></slot>
  </b-tabs>
</template>

<script>
export default {
  name: "TabsVertical",
  props: {
    tabIndex: {
      type: String | Number,
    }
  },
  computed: {
    model: {
      get() {
        return this.tabIndex;
      },
      set(value) {
        this.$router.replace({params: { tab: value }});
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// See tabs.scss for styles
</style>
